/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TouchableOpacity, View } from "react-native";

import {
  skaleBlue,
  skaleWhite,
  skaleWebBorderGray,
  skaleWebFillGray,
  skaleWebTextGray,
  skaleWebTextLightGray,
} from "config/UpduoColors";
import { LoadingDots, Text } from "UpduoLibrary";

interface GraphTabProps {
  isFirst?: boolean;
  isSmall?: boolean;
  isDollars?: boolean;
  value: number | string;
  isActive: boolean;
  onPress?: () => void;
  label: string;
  sublabel?: string;
  durationUnit?: string;
  isLoading?: boolean;
}
export default function GraphTab({
  isFirst = false,
  isSmall = false,
  isDollars = false,
  value,
  isActive,
  onPress,
  label,
  sublabel,
  durationUnit,
  isLoading,
}: GraphTabProps) {
  const tabHighlight = (
    <View
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        width: 5,
        backgroundColor: skaleBlue,
      }}
    />
  );
  const tabSeamHider = (
    <View
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        right: -2,
        width: 4,
        backgroundColor: skaleWhite,
        zIndex: 100,
      }}
    />
  );
  return (
    <TouchableOpacity
      style={{
        backgroundColor: isActive ? skaleWhite : skaleWebFillGray,
        flexDirection: "row",
        alignItems: "center",
        borderTopWidth: isFirst ? 1 : 0,
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderColor: skaleWebBorderGray,
        paddingHorizontal: 10,
        paddingVertical: isSmall ? 5 : 10,
        justifyContent: "space-between",
      }}
      onPress={onPress}
    >
      <View>
        <Text
          style={{
            color: skaleWebTextGray,
            fontSize: isSmall ? 14 : 16,
          }}
        >
          {`${label} `}
          {sublabel ? (
            <Text
              style={{
                color: skaleWebTextLightGray,
                fontSize: isSmall ? 10 : 12,
              }}
            >
              {`(${sublabel})`}
            </Text>
          ) : null}
        </Text>
        <View style={{ flexDirection: "row", alignItems: "flex-end" }}>
          {isLoading ? (
            <View style={{ marginVertical: 5 }}>
              <LoadingDots isAlternate={true} size={isSmall ? 25 : 40} />
            </View>
          ) : (
            <>
              <Text style={{ fontSize: isSmall ? 25 : 40 }}>
                {isDollars ? "$" : ""}
                {isDollars && typeof value === "number"
                  ? value.toFixed(2)
                  : value}
              </Text>
              <View style={{ width: 5 }} />
              {durationUnit ? (
                <Text
                  style={{
                    fontSize: 16,
                    marginBottom: 8,
                    color: skaleWebTextLightGray,
                  }}
                >
                  {durationUnit}
                </Text>
              ) : null}
            </>
          )}
        </View>
      </View>
      <View style={{ width: 10 }} />
      {isActive ? tabHighlight : null}
      {isActive ? tabSeamHider : null}
    </TouchableOpacity>
  );
}
